import React from 'react'
import { Link } from 'gatsby'
import Container from '../components/Container'
import SEO from '../components/SEO'

const NotFoundPage = () => {
  return (
    <Container>
      <SEO
        title="404: Page Not Found • IconJar"
        description="The page you're looking for doesn't exist. Return to IconJar homepage to find what you need for icon management and organization."
        meta={[
          {
            name: 'robots',
            content: 'noindex, nofollow',
          },
        ]}
      />
      <h1>404: Not Found</h1>
      <p>You just hit a route that doesn&#39;t exist... the sadness.</p>
      <Link to="/">Go back to the homepage</Link>
    </Container>
  )
}

export default NotFoundPage
